module.exports = __webpack_public_path__ + "img/coach.8691636e.svg";